import React from "react";
import AxiosConfig from "axiosConfig";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import TextTheme from "../../../../components/General/Text/TextTheme";
/** @import CSS styles */

class Misc extends React.Component {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
			Title: "",
			Content: "",
		};
	}
	componentDidMount() {
		AxiosConfig.get(`misc/page/${this.props.slug}/`)
			.then((res) => {
				this.setState({
					Title: res.data.title,
					Content: res.data.content,
				});
			})
			.catch();
	}
	render() {
		switch (this.props.userState) {
			default:
			case "unregistered":
				return (
					<div className="header_main">
						<div
							className="page_main"
							style={{ display: "flex", justifyContent: "center" }}
						>
							<div className="page_details_main">
								<div className="page_details_content_main" style={{border:"None"}}>
									<div>
										<div style={{textAlign:"center"}}>
										<TextTheme
											message={this.state.Title}
											className="text_large text_dark_blue"
										/>
										</div>
										<br className="br" />
										<div
											dangerouslySetInnerHTML={{
												__html: this.state.Content,
											}}
										></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				);
			case "registered":
				return (
					<div className="header_main">
						<div className="page_main">
							<VerticalSpotlightDetails isSpotlightPage={false} />
							<div className="page_details_main">
								<div className="page_details_content_main">
									<div>
										<div style={{textAlign:"center"}}>
										<TextTheme
											message={this.state.Title}
											className="text_large text_dark_blue"
										/>
										</div>
										<br className="br" />
										<div
											dangerouslySetInnerHTML={{
												__html: this.state.Content,
											}}
										></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				);
		}
	}
}
export default Misc;